```vue
<template>
  <div style="padding: 16px;">
    <vab-query-form>
      <el-button
        v-permission="'GoodsPostageChild_add'"
        icon="el-icon-plus"
        type="primary"
        @click="handleAdd"
      >
        添加
      </el-button>
    </vab-query-form>

    <el-table
      ref="tableSort"
      v-loading="listLoading"
      class="table"
      :data="dataList"
      element-loading-text="加载中"
      :height="height"
      border
    >
      <!-- 名称 -->
      <el-table-column
        prop="name"
        label="名称"
        align="center"
      />

      <el-table-column
        prop="first_number"
        label="首重件数"
        align="center"
      />

      <el-table-column
        prop="first_amount"
        label="首重价格"
        align="center"
      />

      <el-table-column
        prop="repeat_number"
        label="续重件数"
        align="center"
      />

      <el-table-column
        prop="repeat_amount"
        label="续重价格"
        align="center"
      />

      <el-table-column
        prop="add_time"
        label="创建时间"
        align="center"
      />

      <el-table-column
        fixed="right"
        label="操作面板"
        width="130px"
        align="center"
      >
        <template #default="{ row }">
          <el-button
            v-permission="'GoodsPostageChild_edit'"
            type="text"
            @click="edit(row)"
          >
            编辑
          </el-button>

          <el-button
            v-permission="'GoodsPostageChild_del'"
            type="text"
            @click="del(row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增邮费模板弹窗 -->
    <add-postage-dialog
      v-model="addDialogVisible"
      :post-id="query_form.post_id"
      @success="handleAddSuccess"
    />
    <edit-postage-dialog v-model="editDialogVisible" :edit-id="editId" :post-id="query_form.post_id" @success="handleEditSuccess" />
  </div>
</template>

<script>
import {
  goodsPostageList,
  goodsPostageDel
} from '@/api/xgcApi'

import AddPostageDialog from './add.vue'
import EditPostageDialog from './edit.vue'
export default {
  name: 'GoodsPostageList',

  components: {
    AddPostageDialog,
    EditPostageDialog
  },

  data() {
    return {
      height: '73vh',

      query_form: {
        post_id: null,
        page: 1,
        limit: 10,
        total: 0
      },

      listLoading: true,

      // 邮费模版列表
      dataList: [],

      // 新增弹窗
      addDialogVisible: false,
      editDialogVisible: false,
      editId: null
    }
  },

  mounted() {
    this.query_form.post_id = this.$route.query.id

    this.getList()
  },

  methods: {
    /**
     * 删除
     */
    del(id) {
      this.$confirm(
        '此操作将永久删除该数据, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          goodsPostageDel({
            id: id
          }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })

            this.getList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    /**
     * 获取列表
     */
    getList() {
      this.listLoading = true

      goodsPostageList(this.query_form)
        .then(res => {
          this.dataList = res.data.list
          this.query_form.total = res.data.c
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.listLoading = false
        })
    },

    /**
     * 编辑
     *
     * 编辑目前还是按照你原来的方式跳转页面
     */
    edit(row) {
      this.editId = row.id
       this.editDialogVisible = true
    },

    /**
     * 点击添加
     *
     * 不再跳转 add.vue
     * 直接打开弹窗
     */
    handleAdd() {
      this.addDialogVisible = true
    },

    /**
     * 新增成功
     *
     * 子组件保存成功后会触发
     */
    handleAddSuccess() {
      this.addDialogVisible = false

      // 重新获取列表
      this.getList()
    },
    handleEditSuccess() {
      this.addDialogVisible = false

      // 重新获取列表
      this.getList()
    },
  }
}
</script>

<style>
:deep .right-panel {
  display: flex;
  align-items: center;
}

.table {
  margin-top: 30px;
}
</style>
```
